<footer>
    <div [@animateFooter]>
        <ul class="footer-left-bar d-none d-md-block">
            <li>
                <a href="https://github.com/loayeldin" target='_blank'>
                    <i class="fab fa-github"></i>
                </a>
            </li>
            <li>
                <a  href="https://www.linkedin.com/in/loay-eldin-7ab38a14b/" target='_blank'>
                    <i class="fab fa-linkedin-in"></i>
                </a>
            </li>
        </ul>
        <div class="footer-right-bar d-none d-md-block">
            <a  href="loayeldin123@gmail.com" target='_blank'>loayeldin123@gmail.com </a>
        </div>
    </div>

    <div class="footer-credits text-center" >
        <a  href="https://github.com/loayeldin" target="_blank" rel="nofollow noopener noreferrer">
            <div>Built with Angular by Loay elden</div>
        </a>
        <a  href="https://github.com/andresjosehr/andresjosehr-portfolio" target="_blank" rel="nofollow noopener noreferrer">
            <div class="mt-2">Designed by Brittany Chiang & Jośe Andreś</div>
        </a>
    </div>

</footer>